<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="pd-10 bg-white mgb-20">
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <el-form-item label="摄像头序列号">
          <el-input
            v-model="form.num"
            placeholder="请输入摄像头序列号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="摄像头名称">
          <el-input
            v-model="form.name"
            placeholder="请输入摄像头名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="企业">
          <el-input
            v-model="form.customerNum"
            placeholder="请输入企业编号"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <el-form-item label="新增时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--新增 -->
    <btns class="mgb-15" @exec="exec"></btns>
    <!-- 表格 -->
    <el-table :data="tableData" stripe style="width: 100%" border>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="name" label="摄像头名称"> </el-table-column>
      <el-table-column prop="deviceSerial" label="摄像头序列号">
      </el-table-column>
      <el-table-column prop="customerNum" label="企业编号"> </el-table-column>
      <el-table-column prop="createTime" label="新增时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="170">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
          <el-button type="text" size="small" @click="handleDel(scope.row)"
            >解绑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 详情弹框 -->
    <el-dialog
      title="摄像头详情"
      :visible.sync="dialogVisible"
      width="50%"
      center
      :close-on-click-modal="false"
    >
      <el-descriptions border :column="1">
        <el-descriptions-item label="设备名称">{{
          detailForm.deviceName ? detailForm.deviceName : "- -"
        }}</el-descriptions-item>
        <el-descriptions-item label="设备序列号">{{
          detailForm.deviceSerial ? detailForm.deviceSerial : "- -"
        }}</el-descriptions-item>
        <el-descriptions-item label="设备型号">{{
          detailForm.model ? detailForm.model : "- -"
        }}</el-descriptions-item>

        <el-descriptions-item label="设备IP地址">{{
          detailForm.netAddress ? detailForm.netAddress : "- -"
        }}</el-descriptions-item>
        <el-descriptions-item label="设备状态">{{
          detailForm.status === 0
            ? "离线"
            : detailForm.status === 1
            ? "在线"
            : "- -"
        }}</el-descriptions-item>
        <el-descriptions-item label="新增时间">{{
          detailForm.updateTime ? detailForm.updateTime : "- -"
        }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 新增摄像头弹框 -->
    <el-dialog
      title="新增摄像头"
      :visible.sync="addVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="150px"
        :rules="rules"
      >
        <el-form-item label="摄像头名称" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入摄像头名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="摄像头序列号" prop="deviceSerial">
          <el-input
            v-model="addForm.deviceSerial"
            placeholder="请输入摄像头序列号"
          ></el-input>
        </el-form-item>
        <el-form-item label="摄像头验证码" prop="validateCode">
          <el-input
            v-model="addForm.validateCode"
            placeholder="请输入摄像头验证码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCamera('addForm')"
          >新 增</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../utils/UtilsIf";

export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      form: {},
      tableData: [],
      dialogVisible: false,
      detailForm: {},
      addVisible: false,
      addForm: {
        name: "",
        deviceSerial: "",
        validateCode: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入摄像头名称", trigger: "blur" },
        ],
        deviceSerial: [
          { required: true, message: "请输入摄像头序列号", trigger: "blur" },
        ],
        validateCode: [
          { required: true, message: "请输入摄像头验证码", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.camera
        .list({
          pageNum: this.page,
          pageSize: this.pageSize,
          deviceSerial: this.form.num,
          customerNum: this.form.customerNum,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          name: this.form.name,
        })
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.rows;
          }
        });
    },

    add() {
      this.addVisible = true;
      this.addForm = {
        name: "",
        deviceSerial: "",
        validateCode: "",
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addForm.clearValidate();
      });
    },

    addCamera(a) {
      this.$refs[a].validate((valid) => {
        if (valid) {
          handleConfirm("确认新增该摄像头到设备?", "info")
            .then(() => {
              // =====新增接口

              this.$api.camera
                .add({
                  deviceSerial: this.addForm.deviceSerial,
                  name: this.addForm.name,
                  validateCode: this.addForm.validateCode,
                })
                .then((res) => {
                  if (res.code === 200) {
                    this.addVisible = false;
                    this.getList();
                    handleAlert("新增成功", "success");
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    handleDel(row) {
      handleConfirm("确认解绑该摄像头吗?", "info")
        .then(() => {
          this.$api.camera.del({ id: row.id }).then((res) => {
            if (res.code === 200) {
              handleAlert("摄像头已解绑", "success");
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    handleDetail(row) {
      this.$api.camera.detail({ id: row.id }).then((res) => {
        if (res.code === 200) {
          this.detailForm = res.data;
          var dateObj = new Date(this.detailForm.updateTime);
          var year = dateObj.getFullYear();
          var month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
          var day = ("0" + dateObj.getDate()).slice(-2);
          var hours = ("0" + dateObj.getHours()).slice(-2);
          var minutes = ("0" + dateObj.getMinutes()).slice(-2);
          var seconds = ("0" + dateObj.getSeconds()).slice(-2);

          this.detailForm.updateTime =
            year +
            "-" +
            month +
            "-" +
            day +
            " " +
            hours +
            ":" +
            minutes +
            ":" +
            seconds;
        }
      });
      this.dialogVisible = true;
    },

    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    reset() {
      this.form = {};
      this.getList();
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
